import { useState } from "react";
import { Link } from "react-router-dom";
import apiClient, { formatApiErrorDetail } from "@/lib/apiClient";
import { Ship, Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 wave-bg">
      <div className="absolute top-8 left-8">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-10 w-10 bg-orange border-2 border-ink rounded-2xl flex items-center justify-center shadow-nb-sm"><Ship className="h-5 w-5 text-white" /></div>
          <span className="font-display font-700 text-2xl tracking-tight">Tugboat</span>
        </Link>
      </div>
      <div className="max-w-md w-full nb-card p-8" data-testid="forgot-password-page">
        {sent ? (
          <div className="text-center py-4" data-testid="forgot-sent">
            <div className="h-14 w-14 bg-grass border-2 border-ink rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-nb-sm"><MailCheck className="h-7 w-7 text-white" /></div>
            <h1 className="font-display text-3xl font-700 mb-2">Check your inbox</h1>
            <p className="text-ink/60 mb-6">If an account exists for <b>{email}</b>, a reset link is on its way. It expires in 1 hour.</p>
            <Link to="/login" className="nb-btn bg-ink text-cream px-5 py-2.5 text-sm inline-flex">Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-4xl font-700 tracking-tight mb-2">Forgot password?</h1>
            <p className="text-ink/60 mb-7">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="nb-input" placeholder="you@company.com" />
              <button data-testid="forgot-submit" type="submit" disabled={loading}
                className="nb-btn w-full bg-orange text-white py-3.5 text-sm disabled:opacity-60">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </button>
            </form>
            <Link to="/login" className="flex items-center justify-center gap-1.5 text-sm text-ink/60 mt-6 hover:text-orange font-700">
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
